export default function News() {
  return (
    <section id="news" className="px-4 py-8 bg-gray-50">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-xl lg:text-2xl font-bold text-green-900 mb-6">お知らせ・ニュース</h2>
        <div className="space-y-4">
          <div className="bg-white rounded-xl shadow-lg p-4">
            <div className="flex items-start">
              <div className="flex-1">
                <p className="text-xs text-green-500 mb-1">2025.12.01</p>
                <h3 className="text-sm font-medium text-green-900 mb-1">従業員募集</h3>
                <p className="text-xs text-green-600">詳細はお問い合わせください</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-4">
            <div className="flex items-start">
              <div className="flex-1">
                <p className="text-xs text-green-500 mb-1">2025.11.01</p>
                <h3 className="text-sm font-medium text-green-900 mb-1">安全講習を実施</h3>
                <p className="text-xs text-green-600">全社員対象の安全講習を実施し、事故防止への意識を再確認しました。</p>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-lg p-4">
            <div className="flex items-start">
              <div className="flex-1">
                <p className="text-xs text-green-500 mb-1">2025.06.01</p>
                <h3 className="text-sm font-medium text-green-900 mb-1">社員が第2種電気工事士資格を取得</h3>
                <p className="text-xs text-green-600">資格取得を積極的に支援しています。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
